import axiosInstance from '../api/axios';

/**
 * Eventos de interação da Minha Área que o backend aceita registrar.
 *
 * São fatos de tela: nenhum deles chega ao backend por outro caminho — os posts
 * do blog, por exemplo, são buscados direto no WordPress pelo navegador.
 */
export const MinhaAreaEvent = {
  BLOG: 'MINHA_AREA_BLOG',
  BANNER_SUPERIOR_MARKETING: 'MINHA_AREA_BANNER_SUPERIOR_MARKETING',
  BANNER_INFERIOR_MARKETING: 'MINHA_AREA_BANNER_INFERIOR_MARKETING',
  DOSSIE_INCIDENCIAS: 'MINHA_AREA_DOSSIE_INCIDENCIAS',
  DOSSIE_VIDEOAULAS: 'MINHA_AREA_DOSSIE_VIDEOAULAS',
  DOSSIE_EXERCICIOS: 'MINHA_AREA_DOSSIE_EXERCICIOS',
  DOSSIE_MATERIAIS: 'MINHA_AREA_DOSSIE_MATERIAIS',
} as const;

export type MinhaAreaEventName =
  (typeof MinhaAreaEvent)[keyof typeof MinhaAreaEvent];

interface Metadata {
  /** Card do blog e banner: link do destino e posição na listagem. */
  url?: string;
  titulo?: string;
  categoria?: string;
  posicao?: number;
  /** Banner de marketing: id do cadastro e se o link sai da plataforma. */
  bannerId?: string;
  externo?: boolean;
  /** Dossiê: disciplina e módulo abertos. */
  discipline?: string;
  module?: string;
}

/**
 * Registra a interação. O backend deduplica por dia, então trocar de aba e
 * voltar, ou clicar duas vezes no mesmo card, não infla o log.
 *
 * Não é aguardada por nada em tela: falhar aqui não pode atrapalhar a navegação
 * — no caso do blog, o clique abre o post em outra aba e a requisição segue em
 * paralelo.
 */
export async function logMinhaAreaEvent(
  event: MinhaAreaEventName,
  metadata: Metadata = {}
): Promise<void> {
  try {
    await axiosInstance.post('/myarea/eventos', { event, metadata });
  } catch {
    // Log de interação é acessório: silenciar é melhor que estourar na tela.
  }
}
